module.exports = __webpack_public_path__ + "img/MONEY.afff3650.svg";